export const MANAGE_COUNTERS = [
    {
        id: 'pendingApplications',
        analyticsField: 'pendingApplications',
        section: 'applications',
        listStatus: 'submitted',
        parity: 'exact',
    },
    {
        id: 'invitationsSent',
        analyticsField: 'invitationsSent',
        section: 'invitations',
        listStatus: null,
        parity: 'exact',
    },
    {
        id: 'attendees',
        analyticsField: 'totalRegistered',
        section: 'registrations',
        listStatus: null,
        /*
         * BEYANLI SAPMA (Story 17.4 · Blok 17B kararı): kayıt listesi iptal edilmiş
         * satırları ve organizatörün OTOMATİK kaydını da gösterir; sayaç ise
         * "kaç KATILIMCIM var" sorusunu yanıtlar ve ikisini saymaz. Fark ekranda
         * dipnotla yazılıdır (`manage.registrationOrganizerNote`).
         */
        parity: 'subset',
        note: 'liste iptalleri ve organizatörün otomatik kaydını da içerir; sayaç içermez',
    },
];
export function manageCounter(id) {
    const counter = MANAGE_COUNTERS.find((item) => item.id === id);
    if (!counter)
        throw new Error(`unknown manage counter: ${id}`);
    return counter;
}
/**
 * ANALİTİĞİN ETKİN FAZI. Taze kayıt varsa `succeeded` (başka etkinliğin isteği
 * sürerken eldeki sayı titremez); kayıt yok ama tazelenen kopya duruyorsa
 * `loading` (karar sonrası sayı bir istek boyunca kaybolmaz, "0" yazmaz);
 * ikisi de yoksa isteğin kendi fazı (hata "—" basar, "0" değil).
 */
export function manageAnalyticsPhase(analytics, refreshing, requestPhase) {
    if (analytics)
        return 'succeeded';
    if (refreshing)
        return 'loading';
    return requestPhase;
}
/**
 * SAYAÇLARIN ÖNCELİK KURALI: web `useManageEvent` ve mobil `selectManageCounters`
 * BURADAN okur (eskiden iki yerde ayrı yazılıydı ve tazeleme ayağı yalnız webde
 * vardı). Bekleyen başvuru için sıra tazelik sırasıdır:
 *  1. Kuyruk okunduysa O konuşur (liste ile sayaç aynı sunucu yanıtından).
 *  2. Kuyruk yeniden yükleniyor ama analitiğin TAZE kaydı varsa analitik
 *     konuşur: kayıt yalnız son invalidation'dan sonra başlamış istekle yazılır,
 *     yani kararı görmüştür.
 *  3. Taze analitik yoksa kuyruğun KENDİ son sunucu sayımı `loading` fazında
 *     taşınır. Analitiğe düşülmez: kayıt o anda silinmiş olabilir; düşülseydi
 *     rozet kaybolur, KPI "—" olurdu.
 *  4. Kuyruk hiç okunmadıysa analitik (taze ya da tazelenen kopya).
 * Dönüş `Record<ManageCounterId, …>` tipindedir: yeni bir sayaç kimliği iki
 * istemcinin derlemesini birden kırar.
 */
export function manageCounterReadings(input) {
    const { analytics, refreshing, applications } = input;
    const phase = manageAnalyticsPhase(analytics, refreshing, input.analyticsRequestPhase);
    const source = analytics ?? refreshing;
    const queueRefreshing = applications.phase === 'loading' && applications.countsLoaded;
    return {
        pendingApplications: applications.phase === 'succeeded'
            ? { value: applications.submitted, phase: 'succeeded' }
            : queueRefreshing && !analytics
                ? { value: applications.submitted, phase: 'loading' }
                : { value: source?.pendingApplications ?? null, phase },
        invitationsSent: { value: source?.invitationsSent ?? null, phase },
        attendees: { value: source?.totalRegistered ?? null, phase },
    };
}
//# sourceMappingURL=manage-counters.js.map